import { render, staticRenderFns } from "./contributed_projects_tab.vue?vue&type=template&id=5256ca30"
import script from "./contributed_projects_tab.vue?vue&type=script&lang=js"
export * from "./contributed_projects_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports